module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-arrow-down-fill-546f2e42.svg";